import React, { FC, useState } from 'react';

import cx from 'classnames';
import {
  FacebookShareButton,
  PocketShareButton,
  LinkedinShareButton,
  PinterestShareButton,
} from 'react-share';

import { Button as StyledButton, Svg } from './style';
import {
  FacebookIcon,
  FacebookIconReverse,
  LinkedInIcon,
  LinkedInIconReverse,
  PinterestIcon,
  PinterestIconReverse,
  PocketIcon,
  PocketIconReverse,
} from 'styled';

import Language from 'constants/Language';

enum ShareButton {
  FACEBOOK = 'Facebook',
  LINKEDIN = 'LinkedIn',
  PINTEREST = 'Pinterest',
  POCKET = 'Pocket',
}

interface Props {
  className?: string;
  renderBlackIcon: boolean;
  media: string;
}

const SocialShareButtons: FC<Props> = ({
  className,
  renderBlackIcon,
  media,
}) => {
  const [hoverButton, setHoverButton] = useState<ShareButton | null>(null);

  let currentUrl = '';

  if (process.browser) {
    currentUrl = window.location.href;
  }

  const color = renderBlackIcon ? 'black' : 'white';
  const resetHoverButton = () => setHoverButton(null);

  return (
    <div className={cx('SocialShareButtons', className)}>
      <StyledButton
        as={FacebookShareButton}
        url={currentUrl}
        onMouseEnter={() => setHoverButton(ShareButton.FACEBOOK)}
        onMouseLeave={resetHoverButton}
        aria-label={Language.t('SocialShareButtons.socialShareAriaLabel', {
          platform: ShareButton.FACEBOOK,
        })}
      >
        <Svg
          as={
            hoverButton === ShareButton.FACEBOOK
              ? FacebookIconReverse
              : FacebookIcon
          }
          color={color}
        />
      </StyledButton>
      <StyledButton
        as={LinkedinShareButton}
        url={currentUrl}
        onMouseEnter={() => setHoverButton(ShareButton.LINKEDIN)}
        onMouseLeave={resetHoverButton}
        aria-label={Language.t('SocialShareButtons.socialShareAriaLabel', {
          platform: ShareButton.LINKEDIN,
        })}
      >
        <Svg
          as={
            hoverButton === ShareButton.LINKEDIN
              ? LinkedInIconReverse
              : LinkedInIcon
          }
          color={color}
        />
      </StyledButton>
      <StyledButton
        as={PinterestShareButton}
        url={currentUrl}
        media={media}
        onMouseEnter={() => setHoverButton(ShareButton.PINTEREST)}
        onMouseLeave={resetHoverButton}
        aria-label={Language.t('SocialShareButtons.socialShareAriaLabel', {
          platform: ShareButton.PINTEREST,
        })}
      >
        <Svg
          as={
            hoverButton === ShareButton.PINTEREST
              ? PinterestIconReverse
              : PinterestIcon
          }
          color={color}
        />
      </StyledButton>
      <StyledButton
        as={PocketShareButton}
        url={currentUrl}
        onMouseEnter={() => setHoverButton(ShareButton.POCKET)}
        onMouseLeave={resetHoverButton}
        aria-label={Language.t('SocialShareButtons.socialShareAriaLabel', {
          platform: ShareButton.POCKET,
        })}
      >
        <Svg
          as={
            hoverButton === ShareButton.POCKET ? PocketIconReverse : PocketIcon
          }
          color={color}
        />
      </StyledButton>
    </div>
  );
};

export default SocialShareButtons;
